"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionType = void 0;
var QuestionType;
(function (QuestionType) {
    QuestionType["Checkbox"] = "checkbox";
    QuestionType["Dropdown"] = "dropdown";
    QuestionType["Linear"] = "linear";
    QuestionType["LongAnswer"] = "longanswer";
    QuestionType["ShortAnswer"] = "shortanswer";
    QuestionType["SingleChoice"] = "singlechoice";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
